// Minimal, context-free product recommendations loader
(() => {
  const container =
    document.querySelector('product-recommendations') ||
    document.querySelector('[data-product-recommendations]');
  if (!container) return;

  const readAttr = (el, names) => {
    for (const n of names) {
      const v = el.getAttribute(n);
      if (v) return v;
      const key = n.replace(/^data-/, '').replace(/-([a-z])/g, (_, c) => c.toUpperCase());
      if (el.dataset && el.dataset[key]) return el.dataset[key];
    }
    return null;
  };

  const productId = readAttr(container, ['product-id', 'data-product-id']);
  const sectionId = readAttr(container, ['section-id', 'data-section-id', 'data-section']);
  const limit = readAttr(container, ['limit', 'data-limit']) || 4;
  const intent = readAttr(container, ['intent', 'data-intent']) || 'related';

  if (!productId || !sectionId) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const url = `${root}recommendations/products?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}&intent=${encodeURIComponent(intent)}`;

  fetch(url)
    .then((r) => r.text())
    .then((html) => {
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const incoming =
        temp.querySelector('product-recommendations') ||
        temp.querySelector('[data-product-recommendations]');
      if (incoming && incoming.innerHTML.trim()) {
        container.innerHTML = incoming.innerHTML;
        container.style.display = '';
      } else {
        container.remove();
      }
    })
    .catch((e) => console.error('Product recommendations error:', e));
})();
